var _linearGradient, _linearGradient2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgW3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 476.22,
    height: 114.45,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffe052",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc331",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#387eb8",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#366994",
      stopOpacity: 1
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "c",
    x1: 55.549,
    x2: 110.149,
    y1: 77.07,
    y2: 131.853,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "d",
    x1: 89.137,
    x2: 147.777,
    y1: 111.921,
    y2: 168.101,
    gradientUnits: "userSpaceOnUse"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M411.969 93.969c-19.465 0-25.018 19.986-24.125 27.844 0 4.464 1.072 29.311 25 29.124 22.678-.178 23.789-24.467 23.75-28.75-.04-4.11-.34-28.218-24.625-28.218zm.344 6.437c2.23 0 15 .335 15 21.406 0 21.072-8.572 23.22-15 23.22-6.43 0-14.813-3.371-14.813-23.907s12.403-20.719 14.813-20.719z",
    style: {
      opacity: 1,
      color: "#000",
      fill: "#646464",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      marker: "none",
      markerStart: "none",
      markerMid: "none",
      markerEnd: "none",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      visibility: "visible",
      display: "inline",
      overflow: "visible"
    },
    transform: "translate(-44.938 -63.612)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.344 94.156c-15 0-23.563 9.281-23.563 9.281v70.344l9.281 4.281v-31.78s6.442 5 17.157 5c10.714 0 20.719-11.05 20.719-28.907s-8.594-28.219-23.594-28.219zm-1.063 6.063c7.5 0 14.813 3.384 14.813 22.312 0 18.929-8.206 21.781-14.813 21.781-6.607 0-13.031-5-13.031-5l-.188-.156v-34.469s5.72-4.468 13.22-4.468z",
    style: {
      opacity: 1,
      color: "#000",
      fill: "#646464",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      marker: "none",
      markerStart: "none",
      markerMid: "none",
      markerEnd: "none",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      visibility: "visible",
      display: "inline",
      overflow: "visible"
    },
    transform: "translate(-44.938 -63.612)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.357 95.398h9.107v52.857s1.072 13.929-5.893 21.071c-6.964 7.143-23.75 8.393-23.75 8.393l-1.25-5.178s22.322-1.607 22.322-19.107v-7.143s-10.357 4.464-19.286 4.464c-8.928 0-17.857-5.714-17.857-16.25V97.184l9.378-2.513v38.048s-.628 11.607 12.408 11.607c13.035 0 15.178-5 15.178-5l-.357-43.928z",
    style: {
      opacity: 1,
      color: "#000",
      fill: "#646464",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      marker: "none",
      markerStart: "none",
      markerMid: "none",
      markerEnd: "none",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      visibility: "visible",
      display: "inline",
      overflow: "visible"
    },
    transform: "translate(-44.938 -63.612)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.357 80.576 8.929-2.857v17.679h10.357v5.893h-10.357v35.357s-1.25 8.75 10 8.75v5.357s-18.75.179-18.75-12.5v-37.143h-6.072v-5.714h5.893V80.576z",
    style: {
      opacity: 1,
      color: "#000",
      fill: "#646464",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      marker: "none",
      markerStart: "none",
      markerMid: "none",
      markerEnd: "none",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      visibility: "visible",
      display: "inline",
      overflow: "visible"
    },
    transform: "translate(-44.938 -63.612)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m335.357 66.112 8.75-2.5v37.857s9.286-6.428 18.75-6.428 16.25 8.393 16.25 14.107v40.714h-8.75v-36.428s-.893-12.5-10.893-12.5-15.178 6.964-15.178 6.964v42.143h-9.107l.178-83.929z",
    style: {
      opacity: 1,
      color: "#000",
      fill: "#646464",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      marker: "none",
      markerStart: "none",
      markerMid: "none",
      markerEnd: "none",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      visibility: "visible",
      display: "inline",
      overflow: "visible"
    },
    transform: "translate(-44.938 -63.612)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.536 149.862h8.928v-45.536s3.572-4.464 12.679-4.464 12.678 8.214 12.678 10.357v39.643h9.286v-42.678s-1.25-13.036-18.393-13.215c-17.143-.178-25.357 9.286-25.357 9.286l.179 46.607z",
    style: {
      opacity: 1,
      color: "#000",
      fill: "#646464",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      marker: "none",
      markerStart: "none",
      markerMid: "none",
      markerEnd: "none",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      visibility: "visible",
      display: "inline",
      overflow: "visible"
    },
    transform: "translate(-44.938 -63.612)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.406 88.172V78.07h-3.773v-1.352h9.078v1.352h-3.79v10.102h-1.515zm6.82 0V76.718h2.282l2.71 8.11c.25.755.433 1.32.548 1.695.13-.417.333-1.029.609-1.836l2.742-7.969h2.04v11.454h-1.462v-9.586l-3.328 9.586H514l-3.313-9.75v9.75h-1.46z",
    style: {
      fontSize: 16,
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      textAlign: "start",
      lineHeight: "125%",
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#646464",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1,
      fontFamily: "Arial"
    },
    transform: "translate(-44.938 -63.612)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.75 67.469c-28.032 0-26.281 12.156-26.281 12.156l.031 12.594h26.75V96H62.875s-17.938-2.034-17.938 26.25 15.657 27.281 15.657 27.281h9.343v-13.125s-.503-15.656 15.407-15.656h26.531s14.906.241 14.906-14.406V82.125s2.263-14.656-27.031-14.656zM85 75.938a4.808 4.808 0 0 1 4.813 4.812A4.808 4.808 0 0 1 85 85.563a4.808 4.808 0 0 1-4.813-4.813A4.808 4.808 0 0 1 85 75.937z",
    style: {
      opacity: 1,
      color: "#000",
      fill: "url(#c)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      marker: "none",
      markerStart: "none",
      markerMid: "none",
      markerEnd: "none",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      visibility: "visible",
      display: "inline",
      overflow: "visible"
    },
    transform: "translate(-44.938 -63.612)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.546 177.315c28.032 0 26.281-12.156 26.281-12.156l-.03-12.594h-26.75v-3.781h37.374s17.938 2.034 17.938-26.25c0-28.285-15.657-27.282-15.657-27.282h-9.343v13.125s.503 15.657-15.407 15.657h-26.53s-14.907-.241-14.907 14.406v24.219s-2.263 14.656 27.031 14.656zm14.75-8.469a4.808 4.808 0 0 1-4.812-4.812 4.808 4.808 0 0 1 4.812-4.813 4.808 4.808 0 0 1 4.813 4.813 4.808 4.808 0 0 1-4.813 4.812z",
    style: {
      opacity: 1,
      color: "#000",
      fill: "url(#d)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      marker: "none",
      markerStart: "none",
      markerMid: "none",
      markerEnd: "none",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      visibility: "visible",
      display: "inline",
      overflow: "visible"
    },
    transform: "translate(-44.938 -63.612)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgW3);
export default __webpack_public_path__ + "static/media/w3.edbfe851795f38961e0abf8fd9949983.svg";
export { ForwardRef as ReactComponent };